import React from "react";

/* ===================== PANEL ===================== */
import ProductUsagePanel from "../../../components/AdminComponents/ProductUsagePanel/ProductUsagePanel";

/* ===================== ICONS ===================== */
import { PackageSearch } from "lucide-react";

/* ===================== STYLES ===================== */
import styles from "./AdminProductUsage.module.scss";

const AdminProductUsage = () => {
  return (
    <div className={styles["admin-api-usage"]}>
      <div className={styles["admin-api-usage__header"]}>
        <div className={styles["admin-api-usage__icon-wrapper"]}>
          <PackageSearch size={24} strokeWidth={2.5} />
        </div>

        <div className={styles["admin-api-usage__title-group"]}>
          <h2 className={styles["admin-api-usage__title"]}>Product Usage</h2>
          <p className={styles["admin-api-usage__subtitle"]}>
            Monitor product calls, credit consumption, and product execution
            health.
          </p>
        </div>
      </div>

      <ProductUsagePanel />
    </div>
  );
};

export default AdminProductUsage;
